/* eslint-disable */
export const iconFilterInline = `<svg style="cursor:pointer; width:24px; height:25px"  viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6.5H6V7.7759C6 8.24377 6.16403 8.69684 6.46356 9.05627L10.5364 13.9437C10.836 14.3032 11 14.7562 11 15.2241V19.5L13 18.5V15.2241C13 14.7562 13.164 14.3032 13.4636 13.9437L17.5364 9.05627C17.836 8.69684 18 8.24377 18 7.7759V6.5Z" fill="#00395C" fill-opacity="0.8"/>
</svg>`;
